/* unplugin-vue-components disabled */import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  props: {
    type: {
      type: String,
      default: 'datetimerange'
    },
    rangeSeparator: {
      type: String,
      default: '至'
    },
    startPlaceholder: {
      type: String,
      default: '开始日期'
    },
    endPlaceholder: {
      type: String,
      default: '结束日期'
    },
    startValue: {
      type: [String, Number, Date],
      default: ''
    },
    endValue: {
      type: [String, Number, Date],
      default: ''
    },
    valueFormat: {
      type: String,
      default: 'timestamp'
    },
    disabledDate: {
      type: Function,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:startValue', 'update:endValue'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    let dateRange = ref([dayjs(props.startValue).toDate(), dayjs(props.endValue).toDate()]);
    const reg = /^\d+$/;
    watch(() => [props.startValue, props.endValue], () => {
      console.log('props.endValue', props.endValue);
      if (props.startValue && props.endValue) {
        console.log('props.endValue', props.endValue);
        let start;
        if (reg.test(props.startValue) && String(props.startValue).length === 10 && typeof Number(props.startValue) === 'number') {
          start = dayjs(Number(props.startValue) * 1000);
        } else {
          start = dayjs(props.startValue).toDate();
        }
        let end;
        if (reg.test(props.startValue) && String(props.endValue).length === 10 && typeof Number(props.endValue) === 'number') {
          end = dayjs(Number(props.endValue) * 1000);
        } else {
          end = dayjs(props.endValue).toDate();
        }
        dateRange.value = [start, end];
      } else {
        dateRange.value = [];
      }
    });
    watch(() => dateRange.value, val => {
      if (val && val.length === 2) {
        emits('update:startValue', props.valueFormat === 'timestamp' ? dayjs(val[0]).unix() : dayjs(val[0]).format(props.valueFormat));
        emits('update:endValue', props.valueFormat === 'timestamp' ? dayjs(val[1]).unix() : dayjs(val[1]).format(props.valueFormat));
      }
    });
    return (_ctx, _cache) => {
      const _component_el_date_picker = __unplugin_components_0;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_date_picker, {
        modelValue: _unref(dateRange),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(dateRange) ? dateRange.value = $event : dateRange = $event),
        type: __props.type,
        disabled: __props.disabled,
        disabledDate: __props.disabledDate,
        "range-separator": __props.rangeSeparator,
        "start-placeholder": __props.startPlaceholder,
        "end-placeholder": __props.endPlaceholder
      }, null, 8, ["modelValue", "type", "disabled", "disabledDate", "range-separator", "start-placeholder", "end-placeholder"])]);
    };
  }
});